<template>
  <div class="policy" v-html="policy.text">
    
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: "Policy",
  computed: {
  ...mapState("policies", {
      policies: state => state.policies
    }),
    policy() {
      
      var searchIdent = this.$route.params.identifier.replace(/_/, ' ').replace(/-/, ' ').toLowerCase();
      return this.policies.find((policy) => {
        return policy.identifier.toLowerCase() == searchIdent;
      })
    }
  }
}
</script>